<div class="col-12">
  <h1 class="u-mb10 txt txt--section" >
    2. Equipos registrados
  </h1>
  <p class="u-pb20">
    Ingresa los requisitos de conducción para equipos registrados en zona mina.
  </p>
</div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <app-license-detail
          *ngIf="dataRequirement && (mineDocuments || []).length > 0"
          [shouldShowRequestNumberTitle]="false" [shouldShowFlow]="false" [shouldShowEquipmentTitle]="false"
          [shouldShowMineDocumentTable]="true" [shouldShowDocumentLinks]="true"
          [mineDocumentTableForm]="mineDocumentTable"
          [equipments]="equipments"
          [documents]="documents"
          [gettingDataRequirement]="dataRequirementGetting"
          [getDetailsError]="dataRequirementError"
          [mineDocuments]="mineDocuments"
          [assetId]="dataRequirement.assetId"
          >
        </app-license-detail>
        <div *ngIf="dataRequirementError">
          <b>No hay una licencia mina registrada para este conductor en este asset.</b>
        </div>
        <div
        *ngIf="!dataRequirementError && dataRequirementGetting"
        style="display: flex; width: 100%; justify-content: center; height: 70px;">
          <app-loader style="width: 100%;"></app-loader>
        </div>
      </div>
    </div>
  </div>

<button type="button" class="btn btn--primary u-mt60 u-mb10 mr-md-2 modal__trigger send px-5" [ngClass]="{'btn--disabled': !mineDocumentTable.valid || !mineDocuments || mineDocuments.length === 0 || this.mineDocumentTable.controls.length === 0}" data-modal="modal01"
  (click)="  onSubmit()">Actualizar licencia</button>
